import { render, staticRenderFns } from "./CommunityDialog.vue?vue&type=template&id=9fc07f38&scoped=true"
import script from "./CommunityDialog.vue?vue&type=script&lang=js"
export * from "./CommunityDialog.vue?vue&type=script&lang=js"
import style0 from "./CommunityDialog.vue?vue&type=style&index=0&id=9fc07f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc07f38",
  null
  
)

export default component.exports